import React, { Component } from 'react';
import { Button, Card, message } from 'antd';
import { BackBtn } from '@comm/BackBtn';
import { Link } from 'react-router';

import { connect } from 'react-redux';
import { getExpendType } from '@store/modules/finance/expend_type';
import { getIncomeType } from '@store/modules/finance/income_type';

import {
  queryPayableCancel,
  queryPayableConfirm,
  queryPayableDetail,
} from '@api/incubator/payable';
import { queryBusinessIndepositTurn } from '@api/incubator/business';
import TableBase from './TableBase';
import TableBase2 from './TableBase2';
import TableCarry from './TableCarry';
import TableCheck from './TableCheck';

import ModalMatch from './detail/ModalMatch';
import ModalCarry from './detail/ModalCarry';

class PageDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      matchVisible: false,
      carryVisible: false,
      detail: { incomeConfirm: [], turns: [], oldTurns: [] },
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const {
      dispatch,
      params: { uuid },
    } = this.props;
    this.uuid = uuid;
    dispatch(getExpendType()); // 资金流水列表需要类目
    dispatch(getIncomeType());
    this.getPayableDetail();
  }

  componentWillReceiveProps(nextProps) {
    const nextPayableUuid = nextProps.params.uuid;
    const { uuid } = this.props.params;
    if (nextPayableUuid !== uuid) {
      this.uuid = nextPayableUuid;
      this.getPayableDetail();
    }
  }

  handleMatchVisible = flag => {
    this.setState({
      matchVisible: !!flag,
    });
  };

  handleCarryVisible = flag => {
    this.setState({
      carryVisible: !!flag,
    });
  };

  getPayableDetail = uuid => {
    queryPayableDetail({
      uuid: this.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        // 判断账单是否收齐
        this.setState({
          detail: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 匹配流水付款约定确认金额
   */
  payableConfirm = params => {
    queryPayableConfirm({
      payableUuid: this.props.params.uuid,
      ...params,
    }).then(res => {
      if (res.statusCode === 200) {
        this.getPayableDetail();
        this.handleMatchVisible(false);
        message.success(res.message);
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 匹配流水付款约定取消金额
   */
  payableCancel = incomeUuid => {
    queryPayableCancel({
      payableUuid: this.props.params.uuid,
      incomeUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.getPayableDetail();
        message.success(res.message);
      } else {
        message.error(res.message);
      }
    });
  };

  /** 处理转结 */
  handleTurn = params => {
    const { detail } = this.state;
    queryBusinessIndepositTurn({
      ...params,
      newPayableUuid: detail.uuid,
      newBusinessUuid: detail.businessUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.handleCarryVisible(false);
        this.getPayableDetail();
        message.success(res.message);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { matchVisible, carryVisible, detail } = this.state;
    const { incomeConfirm, custom, payableNo, turns, oldTurns } = detail;
    const { accountInfo } = this.props;
    return (
      <div>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
        </div>
        <Card
          title="账单基本信息"
          extra={
            <span>
              合同编号：
              <Link to={`/incubator/contract/${detail.businessUuid}/info`}>{detail.no}</Link>
            </span>
          }
          style={{ marginBottom: '16px' }}
        >
          {detail.payType === 2 ? <TableBase2 detail={detail} /> : null}
          {detail.payType !== 2 ? <TableBase detail={detail} /> : null}
        </Card>
        <Card
          title="匹配流水"
          extra={
            detail.status !== 2 && (accountInfo.isHatcherMng || accountInfo.isIncubatorMng) ? (
              <Button onClick={() => this.handleMatchVisible(true)}>匹配</Button>
            ) : null
          }
          style={{ marginBottom: '16px' }}
        >
          <TableCheck
            dataSource={incomeConfirm}
            onCancel={this.payableCancel}
            custom={custom}
            payableNo={payableNo}
            isArchived={detail.businessIsArchived === 1}
          />
        </Card>
        <Card
          title="结转列表"
          extra={
            detail.status !== 2 && (accountInfo.isHatcherMng || accountInfo.isIncubatorMng) ? (
              <Button onClick={() => this.handleCarryVisible(true)}>结转</Button>
            ) : null
          }
          style={{ marginBottom: '16px' }}
        >
          <TableCarry
            dataSource={{
              turns: turns || [],
              oldTurns: oldTurns || [],
            }}
            custom={custom}
            payableNo={payableNo}
            payableUuid={detail.uuid}
          />
        </Card>
        {matchVisible ? (
          <ModalMatch
            onCancel={() => this.handleMatchVisible(false)}
            onOk={this.payableConfirm}
            customUuid={detail.customUuid}
            incubatorUuid={detail.incubatorUuid}
            incomeTarget={detail.payType === 2 ? 0 : 1}
          />
        ) : null}
        {carryVisible ? (
          <ModalCarry
            onCancel={() => this.handleCarryVisible(false)}
            customUuid={detail.customUuid}
            incubatorUuid={detail.incubatorUuid}
            type={detail.type === 0 ? 0 : 1}
            renewBusinessUuids={[detail.businessUuid]}
            handleTurn={this.handleTurn}
          />
        ) : null}
      </div>
    );
  }
}

export default connect(state => ({
  expendType: state.expend_type,
  incomeType: state.income_type,
  accountInfo: state.account_info,
}))(PageDetail);



// WEBPACK FOOTER //
// ./src/components/incubator/bill/PageDetail.js